export default __webpack_public_path__ + "8ae994a38bd27791f1358a402232cad2.png";